"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (status) { return status >= 300; });
//# sourceMappingURL=checkError.js.map